"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _TitleTypes = _interopRequireDefault(require("../constants/TitleTypes"));

var _ja;

var _default = {
  ja: (_ja = {}, (0, _defineProperty2.default)(_ja, _TitleTypes.default.COMPANY, function (name) {
    return name + " \u5FA1\u4E2D";
  }), (0, _defineProperty2.default)(_ja, _TitleTypes.default.CUSTOMER, function (name) {
    return name + " \u69D8";
  }), _ja)
};
exports.default = _default;
module.exports = exports.default;